var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marquee-wrap"},[_c('div',{staticClass:"scroll"},[_c('p',{staticClass:"marquee"},[_vm._v(_vm._s(_vm.text))]),_c('p',{staticClass:"copy"})]),_c('p',{staticClass:"getWidth"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }